'use client'

import Link from 'next/link'
import React, { useMemo } from 'react'

import {
	LinkProvider,
	MAnnualProgramPreview,
	MDividerImagesA,
	MHeroA,
	MTextA
} from '@medante/react-components'

import type { IMAnnualProgramPreviewProps } from '@medante/react-components/blocks/program/annual-program-preview'
import type { IMDividerImagesAProps } from '@medante/react-components/blocks/divider/divider-images-a'
import type { IMHeroAProps } from '@medante/react-components/blocks/hero/hero-a'
import type { IMTextAProps } from '@medante/react-components/blocks/text/text-a'

import { blockToProps } from './block-to-props'
import { parsePageBuilderHtml } from './parse-page-builder-html'

const ZPageBuilderRenderer = ({ content }: { content: string }) => {
	const blocks = useMemo(() => parsePageBuilderHtml(content ?? ''), [content])

	const elements = useMemo(() => {
		return blocks.map((block, index) => {
			const props = blockToProps(block)
			if (props == null) return null
			const key = block.id ?? `block-${index}`
			switch (block.type) {
				case 'hero-a':
					return <MHeroA key={key} {...(props as unknown as IMHeroAProps)} />
				case 'divider-images-a':
					return (
						<MDividerImagesA
							key={key}
							{...(props as unknown as IMDividerImagesAProps)}
						/>
					)
				case 'text-a':
					return <MTextA key={key} {...(props as unknown as IMTextAProps)} />
				case 'annual-program-preview-a':
					return (
						<MAnnualProgramPreview
							key={key}
							{...(props as unknown as IMAnnualProgramPreviewProps)}
						/>
					)
				default:
					return null
			}
		})
	}, [blocks])

	return (
		<LinkProvider
			value={Link as React.ElementType<React.AnchorHTMLAttributes<HTMLAnchorElement>>}
		>
			<div>{elements}</div>
		</LinkProvider>
	)
}

export default ZPageBuilderRenderer
